module.exports = __webpack_public_path__ + "93dd5b4e0037d58f3417647c13cbad3c.png";